<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Segments
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <div class="px-4 py-5 bg-white sm:p-6 shadow-xl rounded-md">
                    <div class="flex items-center justify-end">
                        <inertia-link
                            v-if="permissions.segments.create"
                            class="rounded-md border border-transparent bg-gray-800 inline-flex items-center px-4 py-2 text-xs text-white uppercase tracking-widest font-semibold hover:bg-gray-700 transition"
                            :href="create_url">
                            Create Segment
                        </inertia-link>
                    </div>

                    <table v-if="segments.length > 0" class="w-full mt-3">
                        <thead class="bg-gray-100">
                        <tr class="text-left border-b">
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">ID</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Name</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Partner</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">ESP ID</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Contacts</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Emails</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Created At</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500 whitespace-nowrap w-1">Actions</th>
                        </tr>
                        </thead>
                        <tbody class="divide-y">
                        <template v-for="segment in segments">
                            <tr v-if="!segment.deleted">
                                <td class="p-2">{{ segment.id }}</td>
                                <td class="p-2">{{ segment.name }}</td>
                                <td class="p-2">{{ segment.partner.name }}</td>
                                <td class="p-2 text-sm font-mono">{{ segment.esp_list_id }}</td>
                                <td class="p-2">{{ countFormatted(segment.contacts) }}</td>
                                <td class="p-2">{{ countFormatted(segment.emails) }}</td>
                                <td class="p-2">{{ segment.created_at }}</td>
                                <td class="p-2 whitespace-nowrap w-1">
                                    <inertia-link
                                        v-if="segment.permissions.edit"
                                        class="rounded-md border border-transparent bg-gray-800 inline-flex items-center px-3 py-0.5 text-xs text-white uppercase tracking-widest font-semibold hover:bg-gray-700 transition"
                                        :href="segment.edit_url">Edit
                                    </inertia-link>
                                    <delete-button :action="route('segments.destroy', segment.id)" @deleted="segment.deleted = true">
                                        <template #content>
                                            Are you sure you want to delete the segment {{ segment.name }}?
                                        </template>
                                        <template #delete-button>Delete Segment</template>
                                    </delete-button>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                    <div v-else class="bg-gray-100 mt-3 rounded-md py-3 px-4">
                        No segments have been created yet
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import {usePage} from '@inertiajs/inertia-vue3';
import DeleteButton from '@/Components/DeleteButton.vue';

export default {
    props: ['segments', 'create_url'],

    components: {
        AppLayout,
        DeleteButton,
    },

    setup() {
        return {
            user: usePage().props.value.auth.user,
            permissions: usePage().props.value.auth.permissions,
            countFormatted(count) {
                return new Intl.NumberFormat().format(count);
            },
        };
    },
};
</script>
